import React from 'react';
import { Box, styled } from '@mui/material';
import Sidebar from './Sidebar';
import Footer from './Footer';
import chatbotLayoutLight from '../assets/images/light/chatbot layout.png';
import summaryIconLight from '../assets/images/light/summary.png';
import chatbotLayoutDark from '../assets/images/dark/chatbot layout_dark.png';
import summaryIconDark from '../assets/images/dark/summary_dark.png';


const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 1100,
  backgroundColor: theme.palette.background.paper
}));

const MainContent = styled(Box)({
  width: '100%',
  flex: '1 0 auto', /* Allow content to grow and push footer down */
  padding: '0',
  position: 'relative',
});

const SummaryTab = styled('div')({
  position: 'fixed',
  top: '40%',
  right: '0',
  transform: 'translateY(-50%)',
  zIndex: 1200,
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-50%) scale(1.05)'
  }
});

const BuddyChatButton = styled('div')({
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  cursor: 'pointer',
  zIndex: 1200,
  '& img': {
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.05)'
    }
  }
});



const DashboardLayout = ({ children, isAdmin, darkMode, handleThemeChange }) => {
  return (
    <LayoutContainer>
      <HeaderContainer>
        <Sidebar isAdmin={isAdmin} darkMode={darkMode} handleThemeChange={handleThemeChange} />
      </HeaderContainer>
      <MainContent>
        {React.cloneElement(children, { darkMode })}

        {/* Summary Tab */}
        <SummaryTab>
          <img 
            src={darkMode ? summaryIconDark : summaryIconLight} 
            alt="Summary" 
            style={{ width: '43px', height: '86px' }} 
          />
        </SummaryTab>

        {/* Chatbot Button */}
        <BuddyChatButton>
          <img 
            src={darkMode ? chatbotLayoutDark : chatbotLayoutLight} 
            alt="Chat" 
            style={{ width: '118px', height: '109px' }} 
          />
        </BuddyChatButton>
      </MainContent>

      <Footer />
    </LayoutContainer>
  );
}

export default DashboardLayout;
